import {
    AnyUpsellAddon,
    AvailableAddonType,
    UpSellAddonBaggage,
} from '@/api/MyBookingSession/myBookingSession.interfaces';
import { ProductType } from '@/api/Cart/cart.interfaces';

export function mapBaggageAddonExcludingExtras(
    addon: UpSellAddonBaggage
): UpSellAddonBaggage {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { InitialPax: _, ...rest } = addon;
    return rest;
}

export function getAddonsByType(
    addons: AnyUpsellAddon[],
    type: AvailableAddonType | ProductType
): AnyUpsellAddon[] {
    if (type === ProductType.Ferry) {
        return addons.filter((addon) => addon.ProductType === type);
    }

    return addons.filter((addon) => addon.Type === type);
}
